import { createContext } from 'react'
import type { AuthContextType } from '@/types'

export const authContext = createContext<AuthContextType | undefined>(undefined)
